// components/MessageTutorModal.js
import React, { useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import { getOrCreateChatBox, sendMessage } from '../../../../store/services/chatService';

export const MessageTutorModal = ({ 
    show, 
    onClose, 
    onSendMessage, 
    tutor, 
    studentId,
    isSending = false 
}) => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSendMessage = async () => {
        if (!message.trim()) {
            setError('Please enter a message');
            return;
        }

        if (!studentId || !tutor?.tutorId) {
            console.log("tutor = ", tutor);
            setError('Missing user information');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            // Create or get chat box using tutorId
            const chatBox = await getOrCreateChatBox(
                studentId,
                tutor.tutorId,
                'student',
                'tutor'
            );

            // Send message using tutorId
            await sendMessage(
                chatBox.id,
                studentId,
                tutor.tutorId,
                message,
                'student',
                'NONE'
            );

            // Call parent handler if provided
            if (onSendMessage) {
                onSendMessage(message);
            }

            // Reset and close
            setMessage('');
            onClose();
            
        } catch (error) {
            console.error('Error sending message:', error);
            setError('Failed to send message. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setMessage('');
        setError('');
        onClose();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleMessageChange = (e) => {
        const value = e.target.value;
        if (value.length <= 500) {
            setMessage(value);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-envelope me-2"></i>
                    Message {tutor?.name}
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                    </Alert>
                )}

                <div className="mb-3">
                    <p className="text-muted mb-2">
                        Send a message to {tutor?.name}. You can ask about their teaching style, 
                        availability, or anything else you'd like to know.
                    </p>
                </div>

                <Form.Group className="mb-3">
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Type your message here..."
                        value={message}
                        onChange={handleMessageChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading || isSending}
                    />
                    <Form.Text className={`text-muted ${message.length >= 500 ? 'text-danger' : ''}`}>
                        {message.length}/500 characters
                    </Form.Text>
                </Form.Group>

                <div className="d-flex align-items-center flex-column justify-content-between">   
                    <div>
                        <Button 
                            variant="secondary" 
                            onClick={handleClose}
                            disabled={isLoading || isSending}
                            className="me-2"
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            onClick={handleSendMessage}
                            disabled={!message.trim() || isLoading || isSending || message.length > 500}
                        >
                            {isLoading || isSending ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Sending...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-paper-plane me-2"></i>
                                    Send Message
                                </>
                            )}
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};